"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastRunType = exports.ForecastRunStatus = void 0;
var ForecastRunStatus;
(function (ForecastRunStatus) {
    ForecastRunStatus[ForecastRunStatus["UNKNOWN"] = -1] = "UNKNOWN";
    ForecastRunStatus[ForecastRunStatus["PENDING"] = 0] = "PENDING";
    ForecastRunStatus[ForecastRunStatus["RUNNING"] = 1] = "RUNNING";
    ForecastRunStatus[ForecastRunStatus["COMPLETED"] = 2] = "COMPLETED";
    ForecastRunStatus[ForecastRunStatus["FAILED"] = 3] = "FAILED";
})(ForecastRunStatus || (exports.ForecastRunStatus = ForecastRunStatus = {}));
var ForecastRunType;
(function (ForecastRunType) {
    ForecastRunType["MANUAL"] = "manual";
    ForecastRunType["AUTOMATIC"] = "automatic";
})(ForecastRunType || (exports.ForecastRunType = ForecastRunType = {}));
